// Polyfill for Buffer global (runtime). Types come from @types/node via tsconfig "types".
import { Buffer as BufferPolyfill } from 'buffer';

declare global {
  interface Window {
    Buffer: typeof BufferPolyfill;
  }
}

// Make Buffer available globally for older dependencies
window.Buffer = BufferPolyfill;
globalThis.Buffer = BufferPolyfill;
